import { Component, OnInit, Input, Output, EventEmitter }                                       from "@angular/core";
import { Observable }                                                                           from "rxjs/Observable";
import { Application, Pagination, ApplicationClaim, ApplicationStatus, ApplicationClaimStatus } from "../../../models";
import { USERHOMECONSTANTS }                                                                    from "../userHome.constants";
import { CurrentUserService }                                                                   from "../../../services/shared";
import { CommonEmitterService }                                                                 from "../../../services/commonEmitter.service";
import { ApplicationAccessService }                                                             from "./applicationAccess.service";
import { UserHomeService }                                                                      from "../userHome.service";
import { NgProgressService }                                                                    from "ng2-progressbar";
import * as swal                                                                                from "sweetalert2";
@Component({
    selector: "application-access",
    template: require("./applicationAccess.component.html"),
    styles: [require("./applicationAccess.component.less").toString()],
    providers: [ApplicationAccessService, CommonEmitterService]
})

export class ApplicationAccessComponent implements OnInit {
    @Input() applicationAccessList: Application[];
    @Input() applicationClaimStatuses: Observable<ApplicationClaimStatus[]>;
    @Input() application: Application;
    @Input() applicationStatuses: Observable<ApplicationStatus[]>;
    @Output() refreshList: EventEmitter<any> = new EventEmitter();
    @Output() refreshApplication: EventEmitter<any> = new EventEmitter();

    selectedApplicationName: string;
    currentApplicationId: string;
    applicationAddEditMode: boolean;
    roleAddEditMode: boolean;
    errorMessage: string;
    activeRoleTabId: number = 0;
    canAddOrEditApplication: boolean;
    isValid: boolean;
    applicationClaimListObservable: Observable<ApplicationClaim[]>;
    applicationsComponent = {
        sortColumnIndex: 1,
        sortOrder: USERHOMECONSTANTS.sorting.ascOrderString,
        sortColumn: "Name",
        pagination: new Pagination(),
        applicationAccessList: new Array<Application>()
    };

    constructor(private currentUserService: CurrentUserService, private applicationAccessService: ApplicationAccessService, private userHomeService: UserHomeService, private pService: NgProgressService) {
        this.applicationsComponent.pagination = {
            totalItems: 0,
            currentPage: USERHOMECONSTANTS.pagination.currentPage,
            itemsPerPage: USERHOMECONSTANTS.pagination.itemsPerPage,
            maxSize: USERHOMECONSTANTS.pagination.maxSize
        };
        this.selectedApplicationName = "";
        this.applicationAddEditMode = false;
        this.roleAddEditMode = false;
        this.isValid = true;
    }

    ngOnInit() {
        // Apply security rules
        // Only global admin can edit account info;
        this.canAddOrEditApplication = this.currentUserService.IsGlobalAdmin();
        this.GetApplicationsList();
    }

    onApplicationAddClick() {
        this.applicationAddEditMode = true;
        this.roleAddEditMode = false;
        let app = new Application();
        app.claims = new Array<ApplicationClaim>();
        this.refreshApplication.emit(app);
    }

    onResetEditMode() {
        this.applicationAddEditMode = false;
        this.roleAddEditMode = false;
        this.refreshApplication.emit(new Application());
    }

    onApplicationEditClick(applicationId) {
        this.applicationAddEditMode = true;
        this.roleAddEditMode = false;
        this.GetApplication(applicationId);
    }

    onRoleEditClick(applicationId) {
        this.roleAddEditMode = true;
        this.applicationAddEditMode = false;
        this.activeRoleTabId = 0;
        this.currentApplicationId = applicationId;
        this.selectedApplicationName = this.applicationAccessList.find(a => a.id === applicationId).name;
        this.applicationClaimListObservable = this.applicationAccessService.GetApplicationClaims(applicationId);
    }

    onSelectRoleTab(tabIndex: number) {
        this.activeRoleTabId = tabIndex;
    };

    public SortIconClass(columnIndex): string {
        if (columnIndex === this.applicationsComponent.sortColumnIndex) {
            if (this.applicationsComponent.sortOrder === USERHOMECONSTANTS.sorting.ascOrderString) {
                return USERHOMECONSTANTS.sorting.ascIconClass;
            } else {
                return USERHOMECONSTANTS.sorting.descIconClass;
            }
        } else {
            return "";
        }
    }

    public SortList(columnIndex: number) {
        if (columnIndex === this.applicationsComponent.sortColumnIndex) {
            if (this.applicationsComponent.sortOrder === USERHOMECONSTANTS.sorting.ascOrderString) {
                this.applicationsComponent.sortOrder = USERHOMECONSTANTS.sorting.descOrderString;
            } else {
                this.applicationsComponent.sortOrder = USERHOMECONSTANTS.sorting.ascOrderString;
            }
        } else {
            this.applicationsComponent.sortOrder = USERHOMECONSTANTS.sorting.ascOrderString;
            switch (columnIndex) {
                case 1:
                    this.applicationsComponent.sortColumn = "Name";
                    break;
                case 2:
                    this.applicationsComponent.sortColumn = "Description";
                    break;
                case 3:
                    this.applicationsComponent.sortColumn = "Url";
                    break;
                default:
                    this.applicationsComponent.sortColumn = "Name";
            }
        }
        this.applicationsComponent.sortColumnIndex = columnIndex;
        this.GetApplicationsList();
    }

    public PageChanged(currentPageObject) {
        this.applicationsComponent.pagination.currentPage = currentPageObject.page;
        this.GetApplicationsList();
    }

    public GetApplication(applicationId: string): void {
        this.applicationAccessService
            .GetApplication(applicationId)
            .subscribe(
            response => {
                this.refreshApplication.emit(response[0]);
            },
            (error) => {
                let parsedErrors = JSON.parse(error._body);
                if (parsedErrors) {
                    this.errorMessage = parsedErrors.message;
                    this.refreshApplication.emit(new Application());
                }
            });
    }

    public onRequestAccessClick(appId: string): void {
        this.pService.start();
        this.isValid = false;
        this.applicationAccessService
            .ApplicationAccess(appId)
            .map(response => response)
            .subscribe(
            response => {

                swal({
                    title: "Application Request",
                    text: "Access to this application will be available once your Principal (or their delegate) has approved your request",
                    type: "info",
                    showCancelButton: false,
                    confirmButtonText: "Okay"
                });

                this.GetApplicationsList();
                this.isValid = true;
                this.pService.done();
            },
            (error) => {
                let parsedErrors = JSON.parse(error._body);
                if (parsedErrors) {
                    this.errorMessage = parsedErrors.message;
                }
            });
           
    }

    public GetApplicationsList(): void {
        this.pService.start();
        this.applicationAccessService
            .GetApplicationList(this.applicationsComponent.pagination, this.applicationsComponent.sortOrder, this.applicationsComponent.sortColumn)
            .map(response => response.json())
            .subscribe(
            response => {
                this.refreshList.emit(<Application[]>response.result);
                this.userHomeService.confirmTotalItemUpdate(response.count);
                this.applicationsComponent.pagination.totalItems = response.count;
                this.pService.done();
            },
            (error) => {
                let parsedErrors = JSON.parse(error._body);
                if (parsedErrors) {
                    this.errorMessage = parsedErrors.message;
                }
            });
    }

    public SortApplications(listToSort: Array<Application>): Array<Application> {
        let sortedList: Array<Application>;
        sortedList = listToSort;
        if (this.applicationsComponent.sortColumn === "Name") {
            sortedList = listToSort.sort((n1, n2) => {
                if (this.applicationsComponent.sortOrder === USERHOMECONSTANTS.sorting.ascOrderString) {
                    if (n1.name > n2.name) {
                        return 1;
                    }
                    if (n1.name < n2.name) {
                        return -1;
                    }
                } else {
                    if (n1.name < n2.name) {
                        return 1;
                    }
                    if (n1.name > n2.name) {
                        return -1;
                    }
                }
                return 0;
            });
        }

        return sortedList;
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/userHome/applicationAccess/applicationAccess.component.ts